<template>
  <ubi-page-container class="ContactsListAll" wide-main-content>
    <no-contact-manager v-if="!possedeContactManager || !possedeCallTracking" />
    <template v-slot:page-actions v-if="possedeContactManager || possedeCallTracking">
          <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" class="inline" v-loading="loadingExport" @click="exporter">
                    {{ $t("portals.report.exportResults") }}
          </el-button>
        </template>
      <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')" v-if="possedeContactManager || possedeCallTracking">
        <ubi-panel>
          <el-row>
            <el-col :lg="24" :md="12">
              <el-row>
                <el-col :lg="12" class="mb-3">
                  <h3 class="mb-4">{{ $t('contacts.contactGenere') }}</h3>
                  <el-row>
                      {{ $t("contacts.listGeneratedEmailContactsTotal") }}
                      <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                          <em class="el-icon-question"></em>
                      </el-tooltip>
                      <span>&nbsp;</span><strong>{{ nbContactsGeneresTotal }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listGeneratedContactsAds") }} <strong>{{ nbContactsGeneres }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.contactUnique") }}
                    <el-tooltip placement="top-start" :content="$t('contacts.contactUniqueTooltips')">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                    <strong> {{ nbContactsUniques }}</strong>
                  </el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listGeneratedCallContactsTotal") }}
                    <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                    <span>&nbsp;</span><strong>{{ nbContactsCall }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>
                      {{ $t("contacts.listActivePortals") }}
                      <strong>{{ nbPortailsActifs }}</strong>
                  </el-row>
                  <el-col> <br></el-col>
                  <el-row>
                      {{ $t("contacts.listAdsSent") }}
                      <strong>{{ nbAnnonces }}</strong>
                  </el-row>
                </el-col>
                <el-col :lg="12" v-if="sitimmoUser.hasScoring">
                  <h3 class="mb-4">{{ $t('qualiforma.donneesQualiforma') }}</h3>
                  <el-row v-if="dataKpi.length > 0">
                    <el-col class="mb-3">
                      {{ $t("qualiforma.nbFormEnvoyes") }} :
                      <strong v-if="scoringOfferType == 'V'">{{ qualiformaKpi.QUALIFORMA_ENVOYE_VENTE }}</strong>
                      <strong v-else-if="scoringOfferType == 'L'">{{ qualiformaKpi.QUALIFORMA_ENVOYE_LOCATION }}</strong>
                      <strong v-else>{{ qualiformaKpi.QUALIFORMA_ENVOYE }}</strong>
                    </el-col>
                    <el-col class="mb-3 col-part" v-if="sitimmoUser.metier == 'AGENCE' && (qualiformaKpi.QUALIFORMA_ENVOYE) && !scoringOfferType">
                      {{ $t("qualiforma.dont") }} :
                      <ul style="margin-left: 35px;">
                        <li><strong>{{ qualiformaKpi.QUALIFORMA_ENVOYE_LOCATION }}</strong> {{ $t("qualiforma.location") }}</li>
                        <li><strong>{{ qualiformaKpi.QUALIFORMA_ENVOYE_VENTE }}</strong> {{ $t("qualiforma.transaction") }}</li>
                      </ul>
                    </el-col>
                    <el-col class="mb-3">
                      {{ $t("qualiforma.nbFormRetournes") }} :
                      <strong v-if="scoringOfferType == 'V'">{{ qualiformaKpi.QUALIFORMA_COMPLETE_VENTE }}</strong>
                      <strong v-else-if="scoringOfferType == 'L'">{{ qualiformaKpi.QUALIFORMA_COMPLETE_LOCATION }}</strong>
                      <strong v-else>{{ qualiformaKpi.QUALIFORMA_COMPLETE }}</strong>
                    </el-col>
                    <el-col class="mb-3 col-part" v-if="sitimmoUser.metier == 'AGENCE' && (qualiformaKpi.QUALIFORMA_COMPLETE) && !scoringOfferType">
                      {{ $t("qualiforma.dont") }} :
                      <ul style="margin-left: 35px;">
                        <li><strong>{{ qualiformaKpi.QUALIFORMA_COMPLETE_LOCATION }}</strong> {{ $t("qualiforma.location") }}</li>
                        <li><strong>{{ qualiformaKpi.QUALIFORMA_COMPLETE_VENTE }}</strong> {{ $t("qualiforma.transaction") }}</li>
                      </ul>
                    </el-col>
                  </el-row>
                  <el-row v-else>
                    <el-col style="font-style: italic;">{{ $t("qualiforma.noData") }}</el-col>
                  </el-row>
                </el-col>
              </el-row>

            </el-col>
          </el-row>
        </ubi-panel>

        <api-search-form
          ref="apiSearchForm"
          :key="$route.fullPath"
          :route="currentRoute"
          :business-domain="sitimmoUser.univers.toLowerCase()"
          :user-context="userContext"
          @search="handleSearchFromApi"
          @config-loaded="handleConfigLoaded"
          @ready="handleSearchFormReady"
        />

        <ubi-panel>
            <ubi-list-header slot="header"
            :key="'header-' + paginationKey"
            :limits="limits"
            :page.sync="page"
            :limit.sync="limit"
            :total="nbResults"
            :sort.sync="sort"
            :sortProperties="sortProperties"></ubi-list-header>

            <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" type="mini" slot="actions" v-loading="loadingExport" @click="exporter">
                {{ $t("contacts.exportResults") }}
            </el-button>
            <ubi-list-footer slot="footer"  :key="'footer-' + paginationKey" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>

            <el-table ref="table" :data="results.contact_mailtracking">
              <el-table-column type="expand">
                <template v-slot="{ row: result }">
                  {{ result.commentaire }}
                  <div>
                    <div v-if="result.codePostal">{{ $t("contacts.listTabMailtrackingPostalCode") }} :  {{ result.codePostal }}</div>
                    <div v-else>{{ $t("contacts.listTabMailtrackingPostalCode") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                  </div>
                  <div>
                    <div v-if="result.ville">{{ $t("contacts.listTabMailtrackingCity") }} :  {{ result.ville }}</div>
                    <div v-else>{{ $t("contacts.listTabMailtrackingCity") }} : {{ $t("contacts.listTabMailtrackingNoInformation") }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  min-width="100">
                <template v-slot:header>
                  <sortable-column-header
                      field="dateEnvoi"
                      :label="$t('contacts.listColumnDate')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('dateEnvoi')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ (new Date(result.dateEnvoi)).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column min-width="140">
                <template v-slot:header>
                  <sortable-column-header
                      field="reference"
                      :label="$t('contacts.listColumnReference')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('reference')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ result.reference }}
                </template>
              </el-table-column>
              <!-- <el-table-column :label="$t('contacts.listColumnLogo')"  min-width="120">
                <template v-slot="{ row: result }">
                  <img
                      alt=""
                      width="70"
                      :src="`${sitimmoUrl}/images/logos/diffuseur/${result.idDiffuseur}.jpg`"
                      :srcset="`${sitimmoUrl}/images/logos/diffuseur/${result.idDiffuseur}.jpg`"
                  />
                </template>
              </el-table-column> -->
              <el-table-column min-width="170">
                <template v-slot:header>
                  <sortable-column-header
                      field="nomPortail"
                      :label="$t('contacts.listColumnPortal')"
                      :currentSort="columnSort"
                      default-direction="desc"
                      :default-active="isActiveDefault('nomPortail')"
                      @sort="handleColumnSort"
                  />
                </template>
                <template v-slot="{ row: result }">
                  {{ result.nomDiffuseur }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')"  min-width="200">
                <template v-slot="{ row: result }">
                  {{ result.identite }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnEmail')"  min-width="160">
                <template v-slot="{ row: result }">
                  {{ result.email }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnPhoneNumber')"  min-width="120">
                <template v-slot="{ row: result }">
                  {{ result.telephone }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnScoring')" min-width="120" v-if="sitimmoUser.hasScoring">
                <template v-slot="{ row: result }">
                  <span v-if="result.scoring && result.scoring !== null">{{ result.scoring }} / {{ result.scoringTotal }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('contacts.listColumnQualification')"
                min-width="130"
                v-if="sitimmoUser.hasLeadsAgentQualification"
              >
                <template v-slot="{ row: result }">
                  <template v-if="rowHasWhatsappThread(result)">
                    <span
                      v-for="b in [contactQualificationBadge(result)]"
                      :key="'qual-' + result.id"
                      class="ContactsListAll__qualification-wrap"
                    >
                      <el-tag
                        size="small"
                        :type="b.elTagType"
                        :effect="b.effect"
                      >
                        {{ b.label }}
                      </el-tag>
                    </span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnConversationDetail')" min-width="200" fixed="right" v-if="sitimmoUser.hasLeadsAgentQualification">
                <template v-slot="{ row: result }">
                  <template v-if="rowHasWhatsappThread(result)">
                    <span v-if="rowWhatsappThreadIsUnreachable(result)">
                      {{ $t('contacts.whatsappUnreachable') }}
                    </span>
                    <span v-else-if="rowWhatsappThreadIsConversationImpossible(result)">
                      {{ $t('contacts.whatsappConversationImpossible') }}
                    </span>
                    <a
                      v-else
                      href="#"
                      @click.prevent="openWhatsappConversationPanel(result)"
                    >
                      {{ $t('contacts.whatsappConversationLink') }}
                    </a>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('contacts.listColumnFormLink')" v-if="sitimmoUser.hasScoring" min-width="180" fixed="right">
                <template v-slot="{ row: result }">
                  <span v-if="result.cryptId !== null"><a :href="getUrlLinkForm(result)" target="_blank">lien du formulaire</a></span>
                </template>
              </el-table-column>
            </el-table>
        </ubi-panel>
      </div>

    <contact-whatsapp-conversation-panel
      :visible.sync="whatsappPanelOpen"
      :prefetched-thread="whatsappPrefetchedThread"
      :fallback-lead-label="whatsappFallbackLead"
      :fallback-property-label="whatsappFallbackProperty"
      :type-offre="whatsappTypeOffre"
    />
  </ubi-page-container>
</template>

<style lang="scss">
  @import "@/theme/_bootstrap.scss";
  .el-loading-spinner {
      top:10%!important;
  }
  .col-part {
    margin-left: 15px;
    margin-top: -12px;
  }
</style>

<script>

import moment from 'moment'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  exportContacts,
  getContactsAll,
  getContactsStatsEnTete,
  getNbCalls,
  orderNbCalls
} from '@/services/contacts'
import downloadexcel from 'vue-json-excel'
import SortableColumnHeader from '@/components/filters/SortableColumnHeader.vue'
import { getKpiGroup } from '@/services/kpi'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { convertApiFiltersToStore } from '@/utils/filterConverter'
import NoContactManager from '@/pages/contacts/NoContactManager.vue'
import ContactWhatsappConversationPanel from '@/pages/contacts/components/ContactWhatsappConversationPanel.vue'
import {
  getContactQualificationBadgeConfig,
  getContactQualificationStateFromRow
} from '@/pages/contacts/contactQualification'
import {
  pickLeadAgentQualificationThread,
  getTypeOffreFromContactsData,
  rowWhatsappThreadIsUnreachable,
  rowWhatsappThreadIsConversationImpossible
} from '@/pages/contacts/whatsappThreadDisplay'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'ContactsListAll',
  inject: ['browserContext'],
  components: {
    UbiPanel,
    UbiPageContainer,
    NoContactManager,
    ContactWhatsappConversationPanel,
    SortableColumnHeader,
    downloadexcel,
    ApiSearchForm
  },
  data () {
    return {
      loading: false,
      loadingExport: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      enTete: null,
      nbResults: 0,
      tagPostSize: 'mini',
      sortProperties: {
        date: this.$t('general.sort.date'),
        reference: this.$t('general.sort.reference'),
        nomPortail: this.$t('general.sort.portalName')
      },
      nbContactsGeneres: 0,
      nbContactsUniques: 0,
      nbContactsGeneresTotal: 0,
      nbContactsCall: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      nbPortailsActifs: 0,
      contacts: null,
      graphData: {},
      annoncesStats: {},
      filters: [],
      sitimmoUrl: processEnvConfig.VUE_APP_SITIMMO_URL,
      columnSort: { field: null, direction: null }, // Pour le tri par colonne
      initialFetchDone: false,
      paginationKey: 0,
      dataKpi: [],
      qualiformaKpi: {},
      scoringOfferType: null,
      whatsappPanelOpen: false,
      whatsappPrefetchedThread: null,
      whatsappFallbackLead: '',
      whatsappFallbackProperty: '',
      whatsappTypeOffre: null
    }
  },
  computed: {
    ...mapState('contactsList', ['filter', 'results']),
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    currentRoute () {
      return 'contact/contacts-all'
    },
    userContext () {
      return {
        userId: this.sitimmoUser.id,
        univers: this.sitimmoUser.univers,
        metier: this.sitimmoUser.metier,
        betaTesteur: this.sitimmoUser.betaTesteur || false,
        hasScoring: this.sitimmoUser.hasScoring || false
      }
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    possedeCallTracking () {
      return getFromSnake(this.sitimmoUser, 'possede_call_tracking')
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return Number(this.filter.page)
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  },
  watch: {
    whatsappPanelOpen (val) {
      if (!val) {
        this.whatsappPrefetchedThread = null
        this.whatsappTypeOffre = null
      }
    }
  },
  beforeMount () {
    // this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    // this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
  },
  mounted () {
    this.filter.sort = 'date'
    this.filter.direction = 'desc'
    // Ne pas appeler fetchList() ici, ApiSearchForm le fera via handleSearchFormReady()
  },
  methods: {
    getUrlLinkForm (result) {
      return `${processEnvConfig.VUE_APP_QUALIFORMA_URL}#/${result.cryptId}`
    },
    openWhatsappConversationPanel (row) {
      if (!row || !row.id) {
        return
      }
      this.whatsappPrefetchedThread = pickLeadAgentQualificationThread(Array.isArray(row.threads) ? row.threads : [])
      if (!this.whatsappPrefetchedThread) {
        return
      }
      this.whatsappFallbackLead = row.identite || ''
      this.whatsappFallbackProperty = row.reference || ''
      this.whatsappTypeOffre = getTypeOffreFromContactsData(row.contactsData)
      this.whatsappPanelOpen = true
    },
    rowHasWhatsappThread (row) {
      return pickLeadAgentQualificationThread(Array.isArray(row && row.threads) ? row.threads : []) !== null
    },
    rowWhatsappThreadIsUnreachable (row) {
      return rowWhatsappThreadIsUnreachable(row)
    },
    rowWhatsappThreadIsConversationImpossible (row) {
      return rowWhatsappThreadIsConversationImpossible(row)
    },
    contactQualificationBadge (row) {
      const state = getContactQualificationStateFromRow(row)
      const config = getContactQualificationBadgeConfig(state)
      return {
        elTagType: config.elTagType,
        effect: config.effect,
        label: this.$t(config.i18nKey)
      }
    },
    async callKpiGroup () {
      if (this.sitimmoUser.hasScoring) {
        if (this.sitimmoUser.scoringOffersTypes && this.sitimmoUser.scoringOffersTypes.length === 1) {
          this.scoringOfferType = this.sitimmoUser.scoringOffersTypes.shift()
        }
        const filter = {}
        const dateDebut = new Date(this.filter.beforeContacts)
        const dateFin = new Date(this.filter.afterContacts)
        filter.metrique = 'QUALIFORMA_COMPLETE,QUALIFORMA_ENVOYE,QUALIFORMA_COMPLETE_LOCATION,QUALIFORMA_COMPLETE_VENTE,QUALIFORMA_ENVOYE_LOCATION,QUALIFORMA_ENVOYE_VENTE'
        filter.date_debut = dateDebut.getFullYear() + '-' + String(dateDebut.getMonth() + 1).padStart(2, '0') + '-' + String(dateDebut.getDate()).padStart(2, '0')
        filter.date_fin = dateFin.getFullYear() + '-' + String(dateFin.getMonth() + 1).padStart(2, '0') + '-' + String(dateFin.getDate()).padStart(2, '0')
        this.dataKpi = await getKpiGroup(filter)
        this.dataKpi.forEach(element => {
          this.qualiformaKpi[element.metric] = element.valeur
        })
      }
    },
    isActiveDefault (field) {
      if (!this.initialFetchDone) {
        return field === 'dateEnvoi'
      }
      return false
    },
    handleColumnSort ({ field, direction }) {
      this.columnSort = { field, direction }
      if (field === 'dateEnvoi') {
        this.filter.sort = 'date'
        this.filter.direction = direction
      }
      if (field === 'reference') {
        this.filter.sort = 'reference'
        this.filter.direction = direction
      }
      if (field === 'nomPortail') {
        this.filter.sort = 'nomPortail'
        this.filter.direction = direction
      }
      // Réinitialiser la pagination à la page 1
      this.setOffset(0)
      this.setPage(1)

      this.fetchList()
    },
    eventAnalytics (category) {
      this.$ga.event('contact_manager_contacts', 'clic', category, this.sitimmoUser.id)
    },
    async exporter (event) {
      this.eventAnalytics('total_contact')
      this.loadingExport = true
      this.filter.exportType = 'contact_mailtracking'
      const metaData = (this.sitimmoUser.metier === 'PROMOTEUR') ? { file: 'contacts_genérés', metier: this.sitimmoUser.metier } : null
      const res = await exportContacts(this.filter, null, null, null, null, metaData)
      this.loadingExport = false
      this.$message(res)
    },
    async getEnTete () {
      this.enTete = await (getContactsStatsEnTete(this.filter))
      if (this.enTete.type === 'error') {
        this.loading = false
        return false
      }
      // calltracking
      const nbCalls = await (getNbCalls(this.filter))
      const statsNbCalls = orderNbCalls(nbCalls)
      this.enTete.infos.nbContactsCall = statsNbCalls.TOTAL_CONTACTS_CALLTRACKING
    },
    ...mapMutations('contactsList', [
      'setPage',
      'setPage',
      'setOffsetPosts',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter',
      'setBeforeContacts',
      'setAfterContacts'
    ]),
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.filter.search = ''
          this.filter.beforeContacts = moment().subtract(7, 'days')
          this.filter.afterContacts = moment()
          this.filter.activeOnly = null
          this.filter.sort = 'date'
          this.filter.hasScoring = null
          type = 'withContacts'
          this.setFilter(this.filter)
          break
      }
      this.filter.presetPosts = type
      this.fetchList()
    },
    async fetchList () {
      // Ne commit au store global QUE si les dates sont définies
      if (this.filter.beforeContacts !== undefined && this.filter.beforeContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      }
      if (this.filter.afterContacts !== undefined && this.filter.afterContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      }
      this.loading = true
      this.nbResults = 0
      this.contacts = null
      await (this.getEnTete(this.filter))
      this.nbContactsGeneres = this.enTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.enTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.enTete.infos.nbAnnonces
      this.nbProspects = this.enTete.infos.nbProspects
      this.nbPortailsActifs = this.enTete.infos.nbPortailsActifs
      this.annoncesStats = this.enTete.infos.infosAnnonces
      this.nbContactsUniques = this.enTete.infos && this.enTete.infos.nbUniqContactsGeneres ? this.enTete.infos.nbUniqContactsGeneres : 0
      this.nbContactsCall = this.enTete.infos.nbContactsCall

      this.callKpiGroup()

      const contacts = await getContactsAll(this.filter)
      if (contacts.type === 'error') {
        this.loading = false
        return false
      }
      this.setResults(contacts)
      if (this.results.contact_mailtracking) {
        this.nbResults = this.results.total_items
        this.contacts = this.results.contact_mailtracking
      }
      this.setPage(this.results.page)
      this.paginationKey++
      this.loading = false
    },
    filtreNegociateur () {
      return ((this.sitimmoUser.id == 342878) || this.sitimmoUser.betaTesteur)
    },
    onHasScoringChange (value) {
      // Réinitialiser la pagination à la page 1 quand on change le filtre hasScoring
      this.setOffset(0)
      this.setPage(1)
      this.addFilter({ hasScoring: value })
      this.fetchList()
    },

    // === MÉTHODES POUR ApiSearchForm ===
    handleSearchFromApi (filters) {
      console.log('🔍 ContactsListAll - Filtres reçus de ApiSearchForm:', filters)

      // Utiliser l'utilitaire de conversion (comme PostsListImmo)
      const convertedFilters = convertApiFiltersToStore(filters, {
        metier: this.sitimmoUser.metier
      })

      console.log('📝 ContactsListAll - Filtres convertis:', convertedFilters)

      // Utiliser addFilter comme PostsListImmo (ApiSearchForm gère les undefined)
      this.addFilter(convertedFilters)

      console.log('✅ ContactsListAll - État final de this.filter:', { ...this.filter })

      // Déclencher la recherche
      this.fetchList()
    },

    handleConfigLoaded (config) {
      console.log('⚙️ ContactsListAll - Config chargée:', config)
    },

    handleSearchFormReady () {
      console.log('✅ ContactsListAll - ApiSearchForm prêt')
      // Ne pas appeler fetchList() ici, ApiSearchForm va automatiquement émettre la recherche
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.ContactsListAll {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }

  /*
   * ElTag (Element UI) ne propage pas class/style parent sur le <span> interne :
   * on cible le .el-tag via un wrapper dédié pour un rayon identique (pilule).
   */
  .ContactsListAll__qualification-wrap .el-tag {
    border-radius: 9999px !important;
  }
}
</style>
